import { render } from "./BannerSection.vue?vue&type=template&id=d89f6918&scoped=true&ts=true"
import script from "./BannerSection.vue?vue&type=script&lang=ts"
export * from "./BannerSection.vue?vue&type=script&lang=ts"

import "./BannerSection.vue?vue&type=style&index=0&id=d89f6918&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89f6918"]])

export default __exports__